<div class="app-container saf-container">
  <app-header (onLangChange)="setLanguage($event)"></app-header>
  <app-card-view cardClass="full-card">
    <app-basic-detail [draft]="draft" [info]="info" [causes]="causes" [hidden]="!(param==='basic')"></app-basic-detail>

    <app-image-upload [draft]="draft" [info]="info" [hidden]="!(param==='image')"></app-image-upload>

    <app-advance-detail [draft]="draft" [info]="info" [param]="param" [hidden]="!(param==='advance')"></app-advance-detail>

    <app-description [draft]="draft" [info]="info" [hidden]="!(param==='desc')"></app-description>

    <app-rewards [draft]="draft" [info]="info" [hidden]="!(param==='rewards')"></app-rewards>
  </app-card-view>
</div>